import { ref } from "vue";
import { defineStore } from "pinia";
import { useSettings } from "@store/settings";
import { isSm, isMd, isXl, isLg } from "@utils/mediaQuery";

export const useGeneral = defineStore("general", () => {
  const $settings = useSettings();

  // topbar
  const topbarDropdownMenus = ref([
    {
      title: $settings.labels.appointment?.singular,
      icon: "inbox01",
      link: { name: "appointment.add", query: { tab: "details" } },
    },
    {
      title: $settings.labels.customer?.singular,
      icon: "users01",
      link: { name: "customer.add" },
    },
    {
      title: $settings.labels.service?.singular,
      icon: "package01",
      link: { name: "service.add", query: { tab: "general" } },
    },
    {
      title: $settings.labels.staff?.singular,
      icon: "briefcase02",
      link: { name: "staff.add", query: { tab: "profile" } },
      visibility: $settings.addons.staffs,
    },
  ]);

  // sidebar
  const sidebarOptions = ref({
    sidebarWidth: "312px",
    sidebarCollapse: false,
    mainMenus: [
      {
        label: "Dashboard",
        icon: "home01",
        route: { name: "dashboard" },
        visibility: true,
      },
      {
        label: "Calendar",
        icon: "calendar",
        route: { name: "calendar" },
        visibility: $settings.addons.calendar,
      },
      {
        label: $settings.labels.appointment?.plural,
        icon: "inbox01",
        route: { name: "appointment.list" },
        visibility: true,
      },
      {
        label: $settings.labels.customer?.plural,
        icon: "users01",
        route: { name: "customer.list" },
        visibility: true,
      },
      {
        label: $settings.labels.payment?.plural,
        icon: "currencyDollarCircle",
        route: { name: "transaction.list" },
        visibility: $settings.addons.payment,
      },
      {
        label: $settings.labels.service?.plural,
        icon: "package01",
        route: { name: "service.list" },
        visibility: true,
      },
      {
        label: $settings.labels.staff?.plural,
        icon: "briefcase02",
        route: { name: "staff.list" },
        visibility: $settings.addons.staffs,
      },
      {
        label: "Notifications",
        icon: "notificationBox",
        route: { name: "notification.list" },
        visibility: true,
      },
      {
        label: "Customizer",
        icon: "magicWand02",
        route: { name: "customizer" },
        visibility: true,
      },
      //   {
      //     label: "Chat Customizer",
      //     icon: "magicWand02",
      //     route: { name: "chat.customizer" },
      //     visibility: true,
      //   },
      // {
      //     label: 'Activity',
      //     icon: 'activity',
      //     link: 'activity.list',
      //     badge: 15
      // },
    ],
    secondaryMenus: [
      {
        label: "Settings",
        icon: "settings01",
        route: { name: "settings" },
      },
      // {
      //     label: 'Support',
      //     icon: 'lifeBuoy01',
      //     link: 'support'
      // },
    ],
  });

  const changeSidebarWidth = () => {
    if (isSm || isMd)
      sidebarOptions.value.sidebarCollapse
        ? (sidebarOptions.value.sidebarWidth = "0px")
        : (sidebarOptions.value.sidebarWidth = "240px");
    else if (isLg)
      sidebarOptions.value.sidebarCollapse
        ? (sidebarOptions.value.sidebarWidth = "81px")
        : (sidebarOptions.value.sidebarWidth = "240px");
    else if (isXl)
      sidebarOptions.value.sidebarCollapse
        ? (sidebarOptions.value.sidebarWidth = "81px")
        : (sidebarOptions.value.sidebarWidth = "312px");
  };

  /**
   * Toggles the side menu between collapsed and expanded states.
   */
  const collapseSideMenu = (status) => {
    if (status) {
      sidebarOptions.value.sidebarCollapse = status;
    } else {
      sidebarOptions.value.sidebarCollapse =
        !sidebarOptions.value.sidebarCollapse;
    }

    changeSidebarWidth();
  };

  // export
  return {
    topbarDropdownMenus,
    sidebarOptions,
    collapseSideMenu,
    changeSidebarWidth,
  };
});
